import { PlanSubmissionKind } from '@ebalance/proto/bfftypes/v1/plan_submission_pb'

import type { PlanAutoSubmitNotices } from '~/models/planAutoSubmitNoticeRows'
import type { SideMenuDot } from '~/models/sideMenuDot'
import { routePaths } from '~/routes/routePaths'

/**
 * 計画種別 → メニュー項目の path。発電販売計画 (AC-PGL-027) は P1-2 で一覧に知らせを出す時に
 * 1 行足す (それまでは backend も発電販売計画の行を返さない)。
 */
const KIND_MENU_PATH: Partial<Record<PlanSubmissionKind, string>> = {
  [PlanSubmissionKind.DEMAND_PROCUREMENT]: routePaths.planProcurement.path,
}

/**
 * AC-SC-042: 自動で提出・出し直しできなかった計画がある計画種別の項目 (「計画提出 > 需要調達計画」)
 * に黄のドットを作る。2 つの一覧 (自動で提出できていない・締切までに出し直せなかった) のどちらかに
 * 1 件あれば出す。親グループ「計画提出」のドットは子の項目からまとめる (`resolveGroupSideMenuDot`)。
 *
 * @param reason 表示文言 (i18n 解決済み)
 */
export const planAutoSubmitNoticeDots = (
  notices: PlanAutoSubmitNotices,
  reason: string,
): Array<readonly [string, SideMenuDot]> => {
  const paths = new Set<string>()
  for (const notice of [...notices.unsubmitted, ...notices.missedDeadline]) {
    const kind = notice.plan?.kind
    const path = kind === undefined ? undefined : KIND_MENU_PATH[kind]
    if (path !== undefined) paths.add(path)
  }
  return [...paths].map(
    (path) => [path, { severity: 'warning', reasons: [reason] }] as const,
  )
}
